export default __webpack_public_path__ + "static/media/45_mobile.8fdb40c1.jpg";